<template>
  <div class="manageMeeting">
    <!--面包屑-->
    <div class="crumbs">
      <span><router-link :to="{name:'EntryPage'}">首页</router-link></span> >
      <span>专题读片</span>
    </div>
    <!--搜索框-->
    <div class="search">
      <div class="subject-select" >
        <el-row :gutter="10">
          <el-col :span="20" style="margin-top:5px">
            <span style="margin-left:0px;" class="label">发送状态：</span>
            <el-select class="mana-select" v-model="sendState" clearable
                       placeholder="全部">
              <el-option v-for="item in tranStatuses" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="label">会议状态：</span>
            <el-select class="mana-select" v-model="status" clearable
                       placeholder="全部" style="font-size:14px;!important">
              <el-option v-for="item in confStatuses" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="confName" class="comm-input" :maxlength="confNameLength" placeholder="请输入会议名称"></el-input>

            <!--<el-button class="mana-query" @click="queryMeeting('1')">查询</el-button>-->
            <div class="mana-query" @click="queryMeeting('1')">查询</div>
          </el-col>

          <el-col :span="4" style="padding-top: 5px;">
            <!--<el-button  @click="addManageMeeting" class="mana-query addnewConf">新增会议-->
            <!--</el-button>-->
            <!-- 点击新增会议 -->
            <div @click="addManageMeeting" class="mana-query addnewConf">新增会议</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--表格-->
    <div class="batch-process">
      <div class="process-text">批量处理：</div>
        <ul class="process-ul">
          <li @click="batchSendTopicConf">
            <i class="iconfont icon-fasong el-button--text"></i>
            <span>发送</span>
          </li>
          <li @click="batchDeleteTopicConf">
            <i class="iconfont icon-shanchu el-button--text"></i>
            <span>删除</span>
          </li>
        </ul>
       </div>
    <!-- </div>
    <p-table :showCheck="showCheck" :head="head" :studyList="studyList" :data="data" :operation="operation"
             :dynamicOperationName="'manageMeeting'" :operationWidth="'130'"
              :cellClassName="cellClassName" :autoheight="autoheight"
             ref="getSelection" @selection="submitSelection" v-loading="loading"></p-table>  -->
             <!-- <p-table  :head="head"  :data="data"
             :dynamicOperationName="'manageMeeting'"   v-loading="loading"></p-table>  -->

  <p-table :showCheck="showCheck" :head="head" :cellClassName="cellClassName" :studyList="studyList" :data="data" :operation="operation" @_operation="_operation_" :autoheight="autoheight"
       v-loading= "loading" :isCamera="true" :withCameraData="withCameraData"   :dynamicOperationName="'manageMeeting'" :operationWidth="'160'"   ref="getSelection" @selection="submitSelection"></p-table>



<page :total="page.total" :allPage="page.allPage" :currentPage="page.currentPage" @current-page="__currentPage"
          @page-size="__pageSize"></page>

    <!--输入密码-->
    <pops :show="popPassword" :title="'输入密码'" @closePop="closePassword" :width="'25%'">
      <div>
        <el-form label-width="100px">
          <el-row>
            <el-col :span="22">
              <el-form-item :span="10" label="密码  :">
                <el-col :span="24">
                  <el-input v-model="ConfPassword" type="password" :maxlength="10" placeholder="请输入会议密码"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!--确定取消按钮-->
        <div class="btn-box">
          <el-button  @click="_inputDetail" class="indetail mana-query">确定</el-button>
          <el-button @click="_cancelPass" class="cancel mana-query">取消</el-button>
        </div>
      </div>
    </pops>
    <right-pops v-if="popShow">
      <router-view/>
    </right-pops>
    <QRcodePage v-if="isShowQR" :QRTitle="QRTitle" :QRId="QRId" :QRType="QRType"  @closeQR="closeQR"></QRcodePage>
  </div>
</template>

<script type="text/ecmascript-6">
  import pTable from '@/components/common/tables/publicTable'
  import page from '@/components/common/page/page'
  import router from '../../../../router'
  import rightPops from '@/components/common/right/rightPops'
  import pops from '@/components/common/pops/pop'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import {changehosArea,changeAge,changeGender,changeSex} from '@/common/js/change'

  import QRcodePage from '@/components/common/base/QRcodePage'
  export default {
    components: {
      pTable,
      page,
      rightPops,
      pops,
      QRcodePage
    },
    // props: {
    //   studyList: {
    //     type: Array,
    //     default() {
    //       return []
    //     }
    //   }
    // },
    data() {
      return {
        studyList:[],
        enterBool: false,//false为详情，true为进入
        popShow: false,
        autoheight:this.getH(),
        showCheck: true,//显示勾选
        sendState: '',
        ConfPassword: '', //会议密码
        popPassword: false,
        sendBool: true, //会议批量发送
        idVal: '', //专题会议id
        loading:false,
        confTime:'',
        strtDaetime:'',
        statTime:'', //会议开始时间
        conTime :'',//服务器时间
        confChairName: '',//登录用户
        tranStatuses: [
          {
            value: '',
            label: '全部'
          },{
          value: '0',
          label: '保存待发'
        },{
          value: '1',
          label: '已发送'
        }],
        status: '',
        confStatuses: [
          {
            value: '',
            label: '全部'
          }, {
          value: '0',
          label: '未开始'
        },{
          value: '3',
          label: '进行中'
        },{
          value: '1',
          label: '结束'
        }],
        confName: '',
        confNameLength: 20,
        listDetail: '', //列表内容
        //table  固定项
        withCameraData:{//因为要后面增加摄像头图标 所以单独提取出来
          props: 'confName',
          label: '会议名称',
          width: '12%'
        },
        head: [
          // {
          //   props: 'confName',
          //   label: '会议名称',
          //   width: '12%'
          // },
          {
            props: 'startDateStr',
            label: '会议时间',
            width: '9%'
          },{
            props: 'timeCount',
            label: '预计用时',
            width: '9%'
          },
          {
            props: 'confAddress',
            label: '会议地点',
            width: '9%'
          },
          {
            props: 'confChairName',
            label: '主持人',
            width: '8%'
          },
          {
            props: 'sendState',
            label: '发送状态',
            width: '7%'
          },
          {
            props: 'status',
            label: '会议状态',
            width: '7%'
          }
        ],
        data: [
          // {
          //   confName: '心脏病和神经系统诊断',
          //   startDateStr: '2017-09-09 12:25',
          //   timeCount: '1小时',
          //   confAddress: '7号楼1607',
          //   confChairName: '王美丽',
          //   sendState: '已发送',
          //   status: '已结束',
          // }
        ],
        operation: [
          {
            operation: '',
            class: 'icon-chakan',
            class2: 'icon-chakan hui',
            title: '查看'
          },
          {
            operation: '',
            class: 'icon-bianji',
            class2: 'icon-bianji hui',
            title: '修改'
          },
          {
            operation: '',
            class: 'icon-jinru',
            class2: 'icon-jinru hui',
            title: '进入'
          },
          {
            operation: '',
            class: 'icon-chexiao',
            class2: 'icon-chexiao hui',
            title: '撤销'
          },
          {
            operation: '',
            class: 'icon-EQcode2',
            class2: 'icon-EQcode2 hui',
            title: '二维码'
          },
        ],
        page: {
          currentPage: 1,
          pageSize: 30,
          total: 0,
          allPage: 0
        },
        isShowQR:false,
        QRId:"",
        QRType:"topic",
        QRTitle:"",
      }
    },
    mounted() {
      setTimeout(() => {
        this._routerEach()
        if (this.$route.path === '/Homepage/ManageMeeting') {
          this.popShow = false
        } else {
          this.popShow = true
        }
      }, 20)
      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.getH()
        }, 50)
      })
      //登录用户信息
      // http.post('/getUserInfo.json').then(res => {
      //   if (res.data.code === _.ERR_OK) {
      //     this.confChairName = res.data.model.userName
      //     this.conTime = new Date(res.data.model.doctorSign).getTime()
      //   }
      // }).catch(() => {

      // })
    },
    methods: {
      closeQR(){
        this.isShowQR=false;
      },
      getH(){
        this.autoheight = document.body.clientHeight - 50 - 40 - 66 - 15 - 46 - 40 - 15//header + crumb + search + padding + send-Del + pages + marinbottom
      },
      queryMeeting(cPage) { //查询
        let page = 0
        if (cPage === '1') {
          page = 1
          this.page.currentPage = 1
        } else {
          page = cPage
          this.page.currentPage = cPage
        }
        let params = {
          sendState: this.sendState,
          status: this.status,
          confName: this.confName,
          currentPage: page,
          pageSize: this.page.pageSize
        }
        http.post('/conference/queryTopicConfList.json', params).then(res => {

          if (res.data.code === _.ERR_OK) {
             this.loading=false;
            this.data = res.data.model

            for (let item of this.data) {
              if (item.status == '0') {
                item.status = '未开始'
              } else if (item.status == '1') {
                item.status = '结束'

              } else if (item.status == '3') {
                item.status = '进行中'
              } else {
                item.status = ' '
              }
              if (item.sendState == '0') {
                item.sendState = '保存待发'
              } else {
                item.sendState = '已发送'
              }
              item.timeCount = item.timeCount + '小时'
            }
            this.page.total = res.data.totalItem

          } else {
               this.loading=false;
            //  message(res.data.msg, false)
          }
        }).catch(err => {

        })
      },
      _operation_(payload) {  //表格操作
       http.post('/getUserInfo.json').then(res => {
        if (res.data.code === _.ERR_OK) {
          this.confChairName = res.data.model.userName
          this.conTime = new Date(res.data.model.doctorSign.replace("-","/")).getTime()
          if (payload.operation === 'icon-jinru') { //进入会议

          if ((payload.sendState=='已发送' && payload.status=='进行中') || (payload.sendState=='已发送' && payload.status=='未开始')) {
            this.listDetail = payload  //存列表内容
            this.idVal = payload.id
            saveLocalStorage(payload.id, 'idVal')
            this.enterBool = true
            if(payload.hasConfPwd === '1') { //有密码
              this.popPassword = true
              let  startDatetime = this.listDetail.startDateStr.replace("-","/");//替换字符，变成标准格式
              this.confTime
              let   d2 = new Date(); //取今天的日期
              let d1 = new Date(Date.parse(startDatetime)); //取会议开始的日期
              let  hosSecond=d1.getTime()-this.conTime  //时间差的毫秒数
              let  statTime=new Date(this.listDetail.startDateStr.replace("-","/")).getTime()
            //  let  startDatetime = this.listDetail.startDateStr.replace("-","/");//替换字符，变成标准格式
            //  let d2 = new Date(); //取今天的日期
            //  let  d1 = new Date(Date.parse(startDatetime)); //取会议开始的日期
            //  let  hosSecond=d1.getTime()-this.conTime  //时间差的毫秒数
            //  let  statTime=new Date(this.listDetail.startDateStr).getTime()
             if(hosSecond >= '1800000') {
                if(this.listDetail.confChairName != this.confChairName) {
                  message('会议不满足进入条件或者用户无权限开始会议', false)
                } else {message('最多只能提前半小时进入会议', false)

                }
              } else if(hosSecond < '1800000'&& this.listDetail.confChairName == this.confChairName  && this.listDetail.status=='未开始') {
                  this.popPassword=false
                this.$confirm('还未到会议时间，是否要提前开始会议', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                }).then(() => {
                  this.popPassword = true
                })
              } else if(hosSecond < '1800000' && this.listDetail.confChairName != this.confChairName && hosSecond >= '0' && this.listDetail.status=='未开始') {
                message('会议不满足进入条件或者用户无权限开始会议', false)
              } else if(this.listDetail.status=='进行中') {
                this.popPassword = true
              } else if(hosSecond < '0') {
                this.popPassword = true
              }
            } else {  //无密码

              this.ConfPassword = ''
              saveLocalStorage(this.ConfPassword, 'ConfPasswordVal')
              let params = {
                id: payload.id,
                confPwd: this.ConfPassword
              }
              let  startDatetime = this.listDetail.startDateStr.replace("-","/");//替换字符，变成标准格式
              this.confTime
              let   d2 = new Date(); //取今天的日期
              let d1 = new Date(Date.parse(startDatetime)); //取会议开始的日期
              let  hosSecond=d1.getTime()-this.conTime  //时间差的毫秒数
              let  statTime=new Date(this.listDetail.startDateStr.replace("-","/")).getTime()

              if(hosSecond >= '1800000') {
                if(this.listDetail.confChairName != this.confChairName) {
                  message('会议不满足进入条件或者用户无权限开始会议', false)
                } else {
                  message('最多只能提前半小时进入会议', false)
                }
              } else if(hosSecond < '1800000'&& this.listDetail.confChairName == this.confChairName && this.listDetail.status=='未开始') {
                this.$confirm('还未到会议时间，是否要提前开始会议', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                }).then(() => {
                  http.post('/conference/enterTopicConf.json', params).then(res => {

                    if (res.data.code === _.ERR_OK) {
                      this.$router.push({name: 'EnterManageMeeting'})
                      this.popShow = true
                    } else {
                      message(res.data.msg, false)
                    }
                  }).catch(err => {
                    errMsg(err)
                  })
                })
              } else if(hosSecond < '1800000' && this.listDetail.confChairName != this.confChairName && hosSecond >= '0' && this.listDetail.status=='未开始') {
                message('会议不满足进入条件或者用户无权限开始会议', false)
              }
              //  else if(this.listDetail.status=='进行中') {

              //   this.$router.push({name: 'EnterManageMeeting'})
                // this.popShow = true
              // }
              else {
                http.post('/conference/enterTopicConf.json', params).then(res => {

                  if (res.data.code === _.ERR_OK) {
                    this.$router.push({name: 'EnterManageMeeting'})
                    this.popShow = true
                  } else {
                    message(res.data.msg, false)
                  }
                }).catch(err => {
                  errMsg(err)
                })
              }
            }
          }
        } else if(payload.operation === 'icon-chakan') { //查看

          this.idVal = payload.id
          saveLocalStorage(payload.id, 'idVal')

           this.enterBool = false

          if(payload.hasConfPwd === '1') {
            this.popPassword = true
          } else {
            this.ConfPassword = ''


            saveLocalStorage(this.ConfPassword, 'ConfPasswordVal')
            this.$router.push({name: 'QueryManageMeeting'})
            this.popShow = true

          }

        } else if(payload.operation === 'icon-bianji') { //修改

          if (payload.sendState == '保存待发') {
            let params = {
              id: payload.id
            }
            http.post('/conference/getTopicConfDetail.json', params).then(res => {
              if (res.data.code === _.ERR_OK) {
                this.$router.push({name: 'ModifyManageMeeting'})
                this.popShow = true
                saveLocalStorage(res.data.model, 'bianjiData')
                saveLocalStorage(true, 'isModify')
              } else {
                  message(res.data.msg, false)
              }
            })
          }
        } else if(payload.operation === 'icon-chexiao') { //撤销
          if (payload.sendState=='已发送' && payload.status=='未开始' && payload.confChairName == this.confChairName) {
            this.$confirm('确定要撤销当前会议吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              http.post('/conference/recallTopicConf.json', {"id": payload.id }).then(res => {

                if (res.data.code === _.ERR_OK) {

                  message(res.data.msg, true)
                  this.queryMeeting('1')
                } else {
                  message(res.data.msg, false)
                }
              })
            })
          }
        } else if (payload.operation === 'icon-EQcode2'){
            //保存代发不显示二维码
            if(payload.sendState === "保存待发"){
              message("该会议为保存待发，无法读取二维码", false)
            }else{
              this.QRId = payload.id+"";
              this.QRTitle= payload.confName;
              this.isShowQR = true;
            }
        }
        }
      }).catch((e) => {
        console.error(e)
      })


      },
      addManageMeeting() {  //新增会议跳转
        this.popShow = true
        this.$router.push({name: 'AddManageMeeting'})
        saveLocalStorage(false, 'isModify')
      },
      closePassword(payload) {  //关闭输入密码弹窗
        this.popPassword = payload
      },
      _inputDetail() { //输入密码弹窗点击确认
        if(this.enterBool) { //进入会议
          if(this.ConfPassword == '') {
            message('输入密码为空', false)
            return false
          }
          let params = {
            id: this.idVal,
            confPwd: this.ConfPassword
          }
          this.popPassword = false
          http.post('/conference/enterTopicConf.json', params).then(res => {
            if (res.data.code === _.ERR_OK) {
               this.popPassword = false
              this.$router.push({name: 'EnterManageMeeting'})
              this.popShow = true
            } else {
              message(res.data.msg, false)
            }
          }).catch(err => {
            errMsg(err)
          })
        } else { //详情页面
          if(this.ConfPassword == '') {
            message('输入密码为空', false)
            return false
          }
          let params = {
            id: this.idVal,
            confPwd: this.ConfPassword
          }
          http.post('/conference/getTopicConfDetail.json', params).then(res => {
            if (res.data.code === _.ERR_OK) {
              this.popPassword = false
              this.popShow = true
              saveLocalStorage(this.ConfPassword, 'ConfPasswordVal')
              this.ConfPassword = ''
              this.$router.push({name: 'QueryManageMeeting'})
            } else {
              message(res.data.msg, false)
            }
          })
        }
      },
      submitSelection(val) {
        this.studyList = val
        if(this.sendBool) {
        //  console.log(val)
          if(val.length == 0) {
            message('请选择至少一条待发送会议', false)
            return false
          }
          this.$confirm('确定要发送当前会议吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            let sendList = val
            let idsVal = ''
            for (let item of sendList) {
              idsVal = idsVal + item.id + ','
            }
            idsVal = idsVal.slice(0,idsVal.length-1)
            http.post('/conference/batchSendTopicConf.json', {"ids": idsVal }).then(res => {
              if (res.data.code === _.ERR_OK) {
                message(res.data.msg, true)
                this.queryMeeting('1')
               this.$refs.listSelection.clearList()

              } else {
                message(res.data.msg)

              }
            })
          })
        } else {
          if(val.length == '0') {
            message('请选择至少一条待发送会议', false)
            return false
          }
          this.$confirm('确定要删除当前会议吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            let recallList = val
            let idsVal = ''
            for (let item of recallList) {
              idsVal = idsVal + item.id + ','
            }
            idsVal = idsVal.slice(0,idsVal.length-1)
            http.post('/conference/batchDeleteTopicConf.json', {"ids": idsVal }).then(res => {
              if (res.data.code === _.ERR_OK) {
                message(res.data.msg, true)
                this.queryMeeting('1')
              } else {
                message(res.data.msg, false)
              }
            })
          })
        }
      },
      batchSendTopicConf() {  //会议发送
        this.sendBool = true
        this.$refs.getSelection.getList()
      },
      batchDeleteTopicConf() {  //会议删除
        this.sendBool = false
        this.$refs.getSelection.getList()
      },
      _cancelPass() {
        this.ConfPassword = ''
        this.popPassword = false
      },
      _routerEach() {
        router.beforeEach((to, from, next) => {
          if (from.name === 'ManageMeeting') {
            this.popShow = true
          } else {
            this.popShow = false
          }
          next()
        })
      },
      cellClassName({row, rowIndex,column,columnIndex}) {
        if (row.status === '进行中' && column.label === '会议状态') {
          return 'color-red';
        } else if (row.status === '未开始' && column.label === '会议状态') {
          return 'color-green';

        }
      },
      __currentPage(payload) {
        this.page.currentPage = payload
        this.queryMeeting(this.page.currentPage)
      },
      __pageSize(payload) {
        this.page.pageSize = payload
        this.queryMeeting(this.page.currentPage)
      },
    },
    created() {
      this.queryMeeting('1')
      this.getH()
      this.loading=true;
    },
    watch: {
      popShow(c, o) {
        if (c === false) {
          this.queryMeeting(this.page.currentPage)
        }
      },
      '$route'() {
        if (this.$route.path === '/Homepage/ManageMeeting') {
          this.popShow = false
        } else {
          this.popShow = true
        }
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'

  .subject-select
    width: 98%
    min-width: 980px
    margin: 0 auto
    background: $color-background-d
    padding: 1%
    .el-col
      height 32px !important
  .label
    display: inline-block
    min-width: 70px
    text-align: right
    color: $color-text
  .comm-input
    width: 260px
    margin-right: 5px
  .mana-select
    width: 122px
    margin-right: 5px
  .mana-query
    display: inline-block
    width: 120px
    height: 28px
    line-height: 28px
    background: $color-background-hover
    color: $button-text-color
    text-align: center
    border-radius: 4px
    cursor: pointer
  .addnewConf
    width: 120px
    height: 27px
    float: right
    top: 7px
    left: 20px
    line-height: 27px
    text-align: center
    cursor: pointer
    background: #f3b200
    color: $color-index-text
    border-radius: 3px
    float right
    background: $button-base-color
  .batch-process
    margin-top: 15px
    height: 46px
    background: $color-background-d
  .process-text
    float: left
    line-height: 46px
    margin-left:25px
  .process-ul
    float: left
    margin-top: 9px
    li
      position: relative
      float: left
      width:68px
      height:28px
      line-height:28px
      border:1px solid #dcdfe6
      color: #000
      border-radius: 2px
      margin-right:10px
      cursor: pointer
    span
      color: #000
      margin-left: 28px
    i
      position: absolute
      left: 6px
      top: 14px
  .indetail , .cancel
    padding: 0
    width: 100px
  .indetail
    margin-left: 50px
  .cancel
    background: $button-del
</style>



// WEBPACK FOOTER //
// manageMeeting.vue?26142438